import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import MultiValueCell from '../../MultiValueCell';

interface Props {
  groups: ReadonlyArray<string>;
}

function GroupsCell({ groups }: Props) {
  return (
    <MultiValueCell
      values={groups}
      none={
        <span className="text-muted-foreground" style={{ fontSize: 'var(--text-sm)' }}>
          <T kind="None" />
        </span>
      }
    />
  );
}

export default observer(GroupsCell);
